import {lazy} from 'react';

export const FundSearchBoxLazy = lazy(() => import(/* webpackChunkName: "fundSearchBox" */ '.'));
